/* eslint-disable */
export default {
  region: 'Região',
  calling: 'Chamadas',
  logout: 'Terminar sessão',
  version: 'Versão',
  settings: 'Definições',
  selectToDialSMS: 'Selecionar para marcar/enviar SMS',
  selectToDial: 'Selecionar para marcar',
  selectToSMS: 'Selecionar para enviar SMS',
  clickToDial: 'Clique para marcar',
  autoCreateLog: 'Criar automaticamente registo de chamadas',
  autoCreateSMSLog: 'Criar automaticamente registo de SMS',
  autoLogCalls: 'Registo automático de chamadas',
  autoLogNotes: 'Registo automático de notas',
  autoLogSMS: 'Registo automático de SMS',
  clickToSMS: 'Clique para SMS',
  logSMSContent: 'Registar conteúdo de SMS',
  clickToDialSMS: 'Clique para marcar/SMS',
  logExtensionCall: 'Registar chamadas de extensão',
  audio: 'Áudio',
  language: 'Idioma',
  feedback: 'Feedback',
  userGuide: 'Novidades',
  quickAccess: 'Definição de acesso rápido',
  report: 'Relatório de análise',
  shareIdea: 'Partilhar ideia',
  openEntityFrom: 'Comportamento do objeto Salesforce',
  ctiPanelSize: 'Tamanho do painel de CTI',
  openInNewTab: 'Abrir num novo separador',
  openInCurrentTab: 'Abrir no separador atual',
  reportIssue: 'Comunicar problema',
  contactSupport: 'Contactar a assistência',
  selectToDialHint:
    'Para uma melhor experiência, selecione o número de telefone a marcar com o RingCentral na página de números de telefone em grande quantidade.',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
